import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.5599 3.33976C20.415 3.23953 20.2463 3.17934 20.0707 3.16529C19.895 3.15125 19.7189 3.18384 19.5599 3.25976L2.55989 11.2598C2.38662 11.3423 2.24075 11.4729 2.13968 11.636C2.03861 11.7991 1.98661 11.9879 1.98989 12.1798C1.99307 12.3715 2.05132 12.5583 2.1577 12.7179C2.26409 12.8775 2.41411 13.0031 2.58989 13.0798L7.99989 15.4498V22.1698L13.8399 17.9998L18.5999 20.0798C18.7249 20.1391 18.8615 20.1699 18.9999 20.1698C19.1837 20.1685 19.3636 20.1166 19.5199 20.0198C19.6576 19.9364 19.7731 19.8211 19.8567 19.6836C19.9402 19.546 19.9894 19.3903 19.9999 19.2298L20.9999 4.22976C21.0104 4.05595 20.9753 3.8824 20.8981 3.7263C20.821 3.5702 20.7044 3.43696 20.5599 3.33976ZM18.0999 17.6798L12.8299 15.3698L15.9999 9.16976L8.34989 13.4198L5.41989 12.1298L18.8899 5.78976L18.0999 17.6798Z",
		fill: "currentColor"
	})
});
export default SvgPaperPlane;
